import { useState } from 'react'
import type { PhoneStatus } from '../types'

interface DialerProps {
  phoneStatus: PhoneStatus
  onCall: (number: string) => void
  disabled?: boolean
}

export function Dialer({ phoneStatus, onCall, disabled = false }: DialerProps) {
  const [number, setNumber] = useState('')
  const isOnline = phoneStatus === 'online' && !disabled

  // Strip non-phone characters, keep +, digits, spaces, dashes, parens
  const sanitized = number.replace(/[^\d+\s\-()]/g, '').trim()
  const isValidNumber = /^\+?\d[\d\s\-()]{2,}$/.test(sanitized)

  const handleCall = (e: React.FormEvent) => {
    e.preventDefault()
    if (isValidNumber && isOnline) {
      onCall(sanitized)
    }
  }

  return (
    <div>
      <p className="font-mono text-xs font-semibold tracking-wider text-gray-400 mb-4">
        DIAL NUMBER
      </p>
      <form onSubmit={handleCall} className="flex gap-3">
        <input
          type="tel"
          placeholder="+43 1 234 5678"
          value={number}
          onChange={e => setNumber(e.target.value)}
          className="flex-1 border border-gray-200 dark:border-gray-700
            bg-white dark:bg-gray-900 px-4 py-3
            text-gray-900 dark:text-gray-100 font-mono text-base
            placeholder-gray-400 dark:placeholder-gray-500
            focus:outline-none focus:ring-2 focus:ring-red-500"
        />
        <button
          type="submit"
          disabled={!isOnline || !isValidNumber}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700
            disabled:opacity-40 disabled:cursor-not-allowed
            text-white font-semibold text-sm px-6 py-3 transition-colors"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          {disabled ? 'Calling...' : 'Call'}
        </button>
      </form>
      {phoneStatus === 'offline' && !disabled && (
        <p className="text-sm text-gray-400 mt-3">Phone is offline</p>
      )}
    </div>
  )
}
